export const COLORS = {
    white: '#ffffff',
    whiteLight: 'rgb(220, 220, 220)',
    whiteDarker: '#CCCCCC',
    whiteExtraDarker: '#8F8F8F',
    whitePrimary: '#F3F6F6',
    black: '#171a1e',
    blackLight: '#2C323A',
    greyAlt: '#a3a3a3',
    greyLight: 'lightgrey',
    grey: 'grey',
    boxShadow: '#888',
    border: '#A3A3A3',
    primary: '#009CCC',//'#408EFF', // dark grey 'rgb(64,142,239)',//
    primaryLight: '#00BCF5',//'#85B8FF', //'rgb(64,142,239, 0.7)',//
    primaryExtraLight: '#1FCBFF',//'#D6E7FF', //'rgb(64,142,239, 0.2)',//
    primaryDark: '#004E66',
    secondary: '#FF474E', // blue
    secondaryLight: '#FF8589',
    secondaryExtraLight: '#FFADB0',
    secondaryDark: '#7A0004',
    //tertiary: '#FF474E',
    //tertiaryLight: '#FF8585',
    //tertiaryExtraLight: '#FFD6D6'

}

//--border: #A3A3A3;
//--primary: #00C5FF;
//--primary - light: #47D4FF;
//--primary - extra - light: #99E7FF;
///*--primary-extra-extra-light: #EBF3FF;*/
//--primary - transparent: rgba(0, 197, 255, 0.1);
//--primary - dark: #009CCC;
//--primary - extra - dark: #007DA3;
//--secondary: #555555;
//--secondary - light: #B8B8B8;
//--secondary - extra - light: #EBEBEB;
//--secondary - transparent: rgba(184, 184, 184, 0.1);
//--secondary - dark: #3D3D3D;
//--tertiary: #FF2D2D;
//--tertiary - light: #FF8585;
//--tertiary - extra - light: #FFD6D6;
//--tertiary - transparent: rgb(255, 45, 45, 0.1);
//--tertiary - dark: #CA2B16;

//export const COLORS = {
//    white: '#fff',
//    whitePrimary: '#F3F6F6',
//    black: '#25283D',
//    greyAlt: '#a3a3a3',
//    greyLight: 'lightgrey',
//    grey: 'grey',
//    boxShadow: '#888',
//    border: '#A3A3A3',
//    primary: '#5ED6E3',//'#408EFF', // dark grey 'rgb(64,142,239)',//
//    primaryLight: '#97E4ED',//'#85B8FF', //'rgb(64,142,239, 0.7)',//
//    primaryExtraLight: '#DCF6F9',//'#D6E7FF', //'rgb(64,142,239, 0.2)',//
//    primaryDark: '#0055CC',
//    secondary: '#555', // blue
//    secondaryLight: '#B8B8B8',
//    secondaryExtraLight: '#EBEBEB',
//    secondaryDark: '#3D3D3D',
//    tertiary: 'rgb(249,87,56)',
//    tertiaryLight: 'rgb(249,87,56, 0.6)',
//    tertiaryExtraLight: 'rgb(249,87,56, 0.3)'

//}



//export const COLORS = {
//    white: '#fff',
//    whitePrimary: '#F3F6F6',
//    black: '#25283D',
//    greyAlt: '#a3a3a3',
//    greyLight: 'lightgrey',
//    grey: 'grey',
//    boxShadow: '#888',
//    border: '#A3A3A3',
//    primary: '#408EFF', // dark grey
//    primaryLight: '#85B8FF',
//    primaryExtraLight: '#D6E7FF',
//    primaryDark: '#0055CC',
//    secondary: '#555', // blue
//    secondaryLight: '#B8B8B8',
//    secondaryExtraLight: '#EBEBEB',
//    secondaryDark: '#3D3D3D',
//    tertiary: '#F25F5C', // orange
//    tertiaryLight: '#F9B5B4',
//    tertiaryExtraLight: '#FDECEC'

//}